export const consts = {
  brand: "NKR",
  contactDetails: {
    phone: "0526053869",
    email: "naveishelly@gmail.com",
    whatsapp: "+972526053869",
    bookingUrl: "https://calendly.com/naveishelly/30min",
    whatsappPrefill: "היי NKR! מתעניין/ת בפרויקט.",
  },

  nav: [
    { label: "שירותים", anchor: "services" },
    { label: "תעשיות", anchor: "industries" },
    { label: "עבודות", anchor: "work" },
    { label: "מחירים", anchor: "pricing" },
    { label: "שאלות", anchor: "faq" },
    { label: "צרו קשר", anchor: "contact" },
  ],

  scarcity: {
    slotsLabel: "מקומות פנויים החודש",
    replyTime: "זמן תגובה: עד 4 שעות · ב'-ה'",
    monthlySlots: 3,
  },

  hero: {
    badge: "פנויים לפרויקטים חדשים",
    titleLine1: "בונים תוכנה",
    titleAccent: "שעובדת.",
    lede:
      "כל מה שצריך כדי להשיק — דפי נחיתה, אפליקציות, אוטומציות, מערכות CRM ובוטים לטלגרם ולוואטסאפ. הכל מותאם, מהיר, ובלי קופסה שחורה.",
    primaryCta: "בואו נתחיל",
    secondaryCta: "מה אנחנו בונים",
    marquee: [
      "דפי נחיתה",
      "Full-Stack",
      "אוטומציות",
      "CRM",
      "בוטים לטלגרם",
      "בוטים לוואטסאפ",
      "AI",
    ],
    trustStrip: {
      label: "בנוי על",
      tools: ["React", "Node.js", "Java", "Stripe", "OpenAI", "Twilio", "MongoDB", "AWS"],
    },
    codePreview: {
      title: "deploy.sh",
      lines: [
        { type: "comment", text: "// NKR — מרעיון לאוויר בשבועות" },
        { type: "code", text: "$ npm run build" },
        { type: "muted", text: "✓ compiled successfully" },
        { type: "code", text: "$ git push origin main" },
        { type: "muted", text: "✓ deployed to production" },
        { type: "code", text: "$ curl /api/health" },
        { type: "success", text: '{"status": "shipped"}' },
      ],
    },
  },

  stats: {
    items: [
      { value: "50+", label: "פרויקטים באוויר" },
      { value: "10K+", label: "שעות עבודה שנחסכו" },
      { value: "24h", label: "זמן חזרה למייל" },
      { value: "100%", label: "הקוד שלכם, נקודה" },
    ],
  },

  services: {
    eyebrow: "מה אנחנו בונים",
    title: "כל מה שהעסק שלכם צריך אונליין.",
    lede:
      "אתרים, מערכות זימון, אוטומציות ובוטים — נבנים מקצה לקצה לעסקים קטנים שרוצים להפסיק לבזבז זמן.",
    items: [
      { key: "landing", title: "דפי נחיתה", desc: "דפים שהופכים גולשים ללקוחות. נטענים בשנייה, נראים מצוין בכל מסך, מוכנים לפרסום מהיום הראשון.", bullets: ["בנוי להמרה", "נטען מיידית", "באוויר תוך 3-7 ימים"] },
      { key: "fullstack", title: "מערכות ואפליקציות", desc: "מערכות אונליין עם התחברות, סליקה ודשבורדים. בנויות כך שהצוות שלכם יוכל לעבוד איתן מהיום הראשון.", bullets: ["נראה מצוין במובייל ובמחשב", "סליקה מובנית", "תמיד אונליין"] },
      { key: "automation", title: "אוטומציות מותאמות", desc: "מחברים בין הכלים שאתם כבר עובדים איתם וחוסכים שעות בשבוע. הכל נבנה סביב איך שאתם באמת עובדים.", bullets: ["מתחבר לכלים שלכם", "התראות בסלאק ובמייל", "מה שיתאים לעסק"] },
      { key: "crm", title: "מערכות CRM וניהול לקוחות", desc: "מערכת שהצוות באמת יפתח כל בוקר. בנויה סביב הזרימה האמיתית שלכם — לא הפוך.", bullets: ["ניהול לקוחות ועסקאות", "הרשאות שונות לכל אדם", "דוחות + ייצוא לאקסל"] },
      { key: "telegram", title: "בוטים לטלגרם", desc: "בוט שעונה, מוכר ומנהל קהילה — 24/7, בלי הפסקות קפה. מתאים לתמיכה, להתראות ולמכירות.", bullets: ["פקודות חכמות", "דשבורד ניהול", "סליקה מובנית"] },
      { key: "whatsapp", title: "בוטים לוואטסאפ", desc: "אוטומציה בערוץ שהלקוחות באמת פותחים. ליד, תמיכה וברודקאסט — הכל דרך הוואטסאפ העסקי.", bullets: ["מחובר לוואטסאפ ביזנס", "תשובות חכמות", "נשמר אוטומטית ברשימת הלקוחות"] },
    ],
  },

  industries: {
    eyebrow: "לפי תעשייה",
    title: "מי הלקוחות שלנו.",
    lede: "מערכות אמיתיות לעסקים כמו שלכם. הקמנו את אלו כבר — ואנחנו יודעים מה עובד.",
    cta: "איך זה עובד",
    items: [
      { slug: "whatsapp-bots-for-real-estate", key: "real-estate", name: "נדל\"ן", tagline: "בוטי וואטסאפ לסוכנויות", outcome: "פי 3 פגישות שנקבעו, בלי לידים שאבדו", icon: "🏡" },
      { slug: "ecommerce-automation", key: "ecommerce", name: "איקומרס", tagline: "אוטומציות הזמנות, תמיכה ושיווק", outcome: "חיסכון של 25+ שעות תפעול בשבוע", icon: "🛒" },
      { slug: "booking-system-for-clinics-and-salons", key: "local-services", name: "מרפאות, חדרי כושר ומספרות", tagline: "זימון תורים אונליין + תזכורות וואטסאפ", outcome: "בלי no-shows. חיסכון של 10+ שעות בשבוע.", icon: "📅" },
    ],
  },

  niches: {
    "whatsapp-bots-for-real-estate": {
      hero: {
        eyebrow: "לסוכנויות נדל\"ן",
        title: "בוט וואטסאפ שמכפיל פי 3 את הפגישות.",
        lede: "תפסיקו לאבד לידים בהודעות. בונים בוט וואטסאפ חכם שתופס, מסנן ומנתב כל פנייה — 24/7 — ישר לסוכנים שלכם.",
        primaryCta: "אני רוצה בוט",
        secondaryCta: "לראות דמו",
        bullets: [
          "תופס כל ליד נכנס, גם ב-2 בלילה",
          "מסנן לפי תקציב, אזור, לוז",
          "מנתב לסוכן הנכון בזמן אמת",
          "בנוי על Cloud API הרשמי של וואטסאפ",
        ],
      },
      problems: {
        title: "למה סוכנויות מאבדות לידים",
        items: [
          "פניות מגיעות ל-5 טלפונים שונים — חצי הולכות לאיבוד.",
          "סוכנים עונים בעוד שעות. עד אז הליד כבר כתב למתחרים.",
          "אין מערכת מעקב, אז לידים חמים מצטננים.",
        ],
      },
      solution: {
        title: "מה אנחנו מספקים",
        items: [
          { t: "אינטייק חכם", d: "הבוט מקבל, אוסף שם + תקציב + אזור, ושולח אישור מיידי." },
          { t: "ניתוב אוטומטי", d: "ליד מנותב לסוכן הנכון לפי אזור / שפה / משמרת." },
          { t: "מעקב ופולואפ", d: "תזכורת אוטומטית אחרי 24 ו-72 שעות אם הליד שותק." },
          { t: "סנכרון ל-CRM", d: "כל ליד נכנס ל-CRM שלכם (או שאנחנו בונים) עם היסטוריית שיחה מלאה." },
        ],
      },
      proof: {
        title: "תוצאה אמיתית",
        quote: "איבדנו ליד אחד מתוך שלושה בגלל הודעות שפספסנו. חודשיים אחרי, פי 3 פגישות, והסוכנים הפסיקו להיות בכוננות בלילה.",
        name: "דניאל ר.",
        role: "מייסד, סוכנות נדל\"ן",
      },
      pricing: {
        title: "השקעה",
        priceFrom: "החל מ-$1,250",
        timeline: "1-2 שבועות לאוויר",
        includes: [
          "הקמה על Cloud API הרשמי",
          "פלואו אינטייק וניתוב מותאם",
          "דשבורד ניהול",
          "אינטגרציה ל-CRM",
          "30 ימי תמיכה אחרי השקה",
        ],
      },
      faq: [
        { q: "צריך וואטסאפ ביזנס?", a: "כן — נדאג להקמה על Cloud API הרשמי. האישור לוקח כמה ימים, אנחנו מטפלים בבקשה." },
        { q: "אפשר לנתב לפי אזור / סוכן?", a: "כן. ראונד-רובין, לפי אזור, לפי שפה, לפי משמרת — כל לוגיקה שתרצו." },
        { q: "מה לגבי ה-CRM הקיים?", a: "אנחנו מתחברים לרוב ה-CRMs (Salesforce, HubSpot, Monday, וגם custom). אם אין לכם — נבנה." },
      ],
    },

    "ecommerce-automation": {
      hero: {
        eyebrow: "למותגי איקומרס",
        title: "חיסכון של 25+ שעות בשבוע באוטומציה חכמה.",
        lede: "די להעתיק הזמנות בין שופיפיי, גיליון המחסן והמייל. אנחנו בונים אוטומציה שעובדת בזמן שאתם ישנים — וצומחת איתכם.",
        primaryCta: "להפעיל אוטומציה",
        secondaryCta: "לראות דוגמאות",
        bullets: [
          "הזמנה → מחסן → מדבקה → שילוח, אוטומטי לחלוטין",
          "מענה תמיכה אוטומטי על בסיס מאגר הידע שלכם",
          "פלואו של עגלה נטושה ופוסט-קנייה בוואטסאפ",
          "דשבורדים מותאמים מעל Shopify / WooCommerce / custom",
        ],
      },
      problems: {
        title: "איפה הולך זמן התפעול",
        items: [
          "להעתיק הזמנות לגיליון המחסן בכל בוקר.",
          "לחזור על אותה תשובת תמיכה 50 פעם בשבוע.",
          "החזרים והחלפות בין 4 טאבים שונים.",
        ],
      },
      solution: {
        title: "מה אנחנו מספקים",
        items: [
          { t: "פייפליין הזמנות", d: "הזמנה → מדבקה → מחסן → מעקב — אוטומטי, עם התראות סלאק לחריגים." },
          { t: "אינבוקס תמיכה עם AI", d: "תשובות AI מבוססות מאגר הידע שלכם. רק החשוב באמת מועבר לאדם." },
          { t: "פלואו וואטסאפ", d: "עגלה נטושה ופוסט-קנייה בערוץ שהלקוחות באמת פותחים." },
          { t: "דשבורד תפעול", d: "הזמנות, החזרים ועומס תמיכה — הכל במקום אחד." },
        ],
      },
      proof: {
        title: "תוצאה אמיתית",
        quote: "חתכנו ~25 שעות תפעול ידני בשבוע. הצוות הפסיק לחשוש מימי שני.",
        name: "אור ק.",
        role: "מנהל שיווק, מותג DTC",
      },
      pricing: {
        title: "השקעה",
        priceFrom: "החל מ-$1,250",
        timeline: "1-2 שבועות לאוויר",
        includes: [
          "אוטומציות n8n / מותאמות",
          "אינטגרציות Shopify / WooCommerce / custom",
          "אינבוקס תמיכה AI",
          "אחסון + ניטור",
          "30 ימי תמיכה אחרי השקה",
        ],
      },
      faq: [
        { q: "זה יעבוד עם הת'מה הקיימת?", a: "כן — vanilla Shopify, headless, WooCommerce או stack מותאם." },
        { q: "צריך להחליף כלים?", a: "לא. אנחנו בונים מעל מה שכבר יש. כלי חדש נכנס רק אם יש לו ROI ברור." },
        { q: "ומה עם תמיכה בעברית?", a: "תומכים בפלואו רב-לשוני, כולל RTL בעברית." },
      ],
    },

    "booking-system-for-clinics-and-salons": {
      hero: {
        eyebrow: "למרפאות, חדרי כושר ומספרות",
        title: "מערכת זימון תורים שהלקוחות שלכם באמת ישתמשו בה.",
        lede: "די לרדוף אחרי no-shows ולענות על שיחות זימון כל היום. הלקוחות מזמינים תור מהפלאפון, מקבלים תזכורת בוואטסאפ, והדלפק נרגע סוף סוף.",
        primaryCta: "אני רוצה מערכת",
        secondaryCta: "איך זה נראה",
        bullets: [
          "לקוחות מזמינים מהפלאפון 24/7 — בלי שיחות",
          "תזכורות אוטומטיות בוואטסאפ — בלי no-shows",
          "כל המידע על הלקוחות במקום אחד — לא במחברת",
          "מקדמה בזמן הזימון — ה-no-shows כמעט נעלמים",
        ],
      },
      problems: {
        title: "איפה היום נעלם",
        items: [
          "חצי הבוקר עונים על שיחות 'יש תור?'",
          "ביטולים ברגע האחרון — והשעה לא חוזרת.",
          "פרטי הלקוחות פזורים בין נייר, וואטסאפ והראש שלכם.",
        ],
      },
      solution: {
        title: "מה אנחנו בונים",
        items: [
          { t: "זימון תורים אונליין", d: "הלקוח בוחר שעה מהיומן שלכם. בלי שיחה, בלי טירוף." },
          { t: "תזכורות אוטומטיות", d: "תזכורת בוואטסאפ ו-SMS, 24 שעות ושעתיים לפני. ה-no-shows נעלמים בשקט." },
          { t: "רשימת לקוחות", d: "רשימה אחת נקייה עם הערות, היסטוריה ותגיות. כמו הזיכרון שלכם, אבל עם חיפוש." },
          { t: "מקדמה בזמן הזימון", d: "מקדמה קטנה בעת ההזמנה. בעיית ה-no-show נפתרת מעצמה." },
        ],
      },
      proof: {
        title: "תוצאה אמיתית",
        quote: "איבדנו שני לקוחות בשבוע ל-no-shows. אחרי שהוספנו תזכורות ומקדמה קטנה, היומן נשאר מלא והטלפון הפסיק לצלצל כל היום.",
        name: "אבי מ.",
        role: "בעלים, מספרה",
      },
      pricing: {
        title: "השקעה",
        priceFrom: "החל מ-$1,500",
        timeline: "1-2 שבועות לאוויר",
        includes: [
          "עמוד זימון אונליין מותאם",
          "תזכורות וואטסאפ + SMS",
          "רשימת לקוחות עם הערות ותגיות",
          "מקדמות / סליקה אונליין (אופציונלי)",
          "30 ימי תמיכה אחרי השקה",
        ],
      },
      faq: [
        { q: "הלקוחות שלי באמת ישתמשו בזה?", a: "כן. הזמנת תור היא 2 לחיצות, התזכורת מגיעה בוואטסאפ. בלי הורדת אפליקציה. עובד על כל פלאפון, גם ישן." },
        { q: "מה עם הצוות שלי שלא חזק במחשבים?", a: "צד הניהול בנוי כמו אקסל נקי — רק יותר פשוט. אנחנו מדריכים את הצוות תוך חצי שעה." },
        { q: "אפשר לקחת מקדמות?", a: "כן. מקדמה קטנה בזמן ההזמנה כמעט מבטלת את ה-no-shows. מתחברים ל-Bit, אשראי או העברה בנקאית." },
        { q: "זה יעבוד עם מה שיש לי היום?", a: "מחליפים את המחברת או האקסל במשהו מהיר, או מתחברים למערכת שיש לכם כבר." },
      ],
    },
  },

  portfolio: {
    eyebrow: "מבחר עבודות",
    title: "פרויקטים אמיתיים, תוצאות אמיתיות.",
    lede: "כמה פרויקטים אחרונים — מה הייתה הבעיה, מה בנינו ומה השתנה.",
    cta: "לפרטי הפרויקט",
    items: [
      { slug: "saas-dashboard", key: "saas-dashboard", tag: "SaaS · Full-Stack", title: "דשבורד אנליטיקס לחברת SaaS", problem: "צוות התמיכה הוציא שעות ביום על משיכת נתונים מ-3 כלים שונים.", solution: "בנינו דשבורד בזמן אמת עם הרשאות, התראות וייצוא ל-CSV.", result: "זמן הפקת דוחות ירד מ-4 שעות ביום לפחות מ-5 דקות.", stack: ["React", "Node.js", "PostgreSQL"] },
      { slug: "wa-leadbot", key: "wa-leadbot", tag: "בוט וואטסאפ · CRM", title: "בוט ניהול לידים בוואטסאפ לסוכנות תיווך", problem: "הסוכנים פספסו לידים כי הודעות הלכו לאיבוד בין מכשירים.", solution: "בוט Cloud API שמנתב לידים ל-CRM ייעודי עם מענה אוטומטי ומעקבים.", result: "פי 3 פגישות שנקבעו בחודש הראשון.", stack: ["WhatsApp Cloud API", "Node.js", "MongoDB"] },
      { slug: "landing-conversion", key: "landing-conversion", tag: "דף נחיתה", title: "דף נחיתה ממיר למאמן כושר", problem: "הדף הקודם היה איטי, גנרי, והמיר פחות מאחוז מתנועת הפרסום.", solution: "בנייה מחדש עם קופי שמוכר, טעינה מהירה ושילוב יומן הזמנות.", result: "אחוז ההמרה קפץ מ-0.8% ל-5.2%.", stack: ["React", "Stripe", "Calendly"] },
      { slug: "ops-automation", key: "ops-automation", tag: "אוטומציה", title: "אוטומציית הזמנות לחנות איקומרס", problem: "הזמנות הועברו ידנית בין שופיפיי, גיליון המחסן והמייל.", solution: "פלואו ב-n8n שמסנכרן הזמנות, מדפיס מדבקות ומעדכן את המחסן בסלאק.", result: "חיסכון של ~25 שעות עבודה ידנית בשבוע.", stack: ["n8n", "Shopify API", "Slack"] },
      { slug: "tg-community", key: "tg-community", tag: "בוט טלגרם", title: "בוט קהילה וסליקה לערוץ טלגרם בתשלום", problem: "אישורים ידניים וסליקה ב-Bit/PayBox לא הסתדרו עם מאות חברים.", solution: "בוט טלגרם עם שער תשלום, אונבורדינג אוטומטי ודשבורד ניהול.", result: "צירוף חבר חדש בתשלום בפחות מדקה.", stack: ["Telegram Bot API", "Node.js", "Stripe"] },
      { slug: "clinic-booking", key: "clinic-booking", tag: "זימון תורים · עסק קטן", title: "מערכת זימון ותיק לקוחות למרפאה משפחתית", problem: "פרטי המטופלים חיו במחברת ובאקסל. תזכורות יצאו ידנית — כשהיה זמן.", solution: "עמוד זימון אונליין עם תזכורות וואטסאפ אוטומטיות, רשימת מטופלים נקייה ומקדמות בזמן הזימון.", result: "ה-no-shows ירדו מ-22% ל-4%. לדלפק יש סוף סוף זמן לנשום.", stack: ["React", "Node.js", "WhatsApp API"] },
    ],
    detail: {
      backToHome: "→ חזרה לאתר",
      problemLabel: "הבעיה",
      solutionLabel: "מה בנינו",
      resultLabel: "התוצאה",
      stackLabel: "סטאק",
      ctaTitle: "רוצים משהו דומה?",
      ctaDesc: "אפשר לבנות לכם משהו דומה — בדרך כלל באוויר תוך 2-4 שבועות.",
      ctaButton: "התחילו פרויקט",
      relatedTitle: "עבודות נוספות",
    },
  },

  testimonials: {
    eyebrow: "מה לקוחות אומרים",
    title: "צוותים שמשיקים סומכים עלינו.",
    lede: "אנחנו גאים בקשרים שאנחנו בונים, לא רק בקוד.",
    logosLabel: "סומכים עלינו",
    logos: [
      { name: "ד\"ר שי ת." },
      { name: "דולב ה." },
      { name: "צחי י." },
      { name: "ניצן א." },
      { name: "עומר ג." },
    ],
    items: [
      { quote: "קביעת תורים היתה אוכלת לי את אחרי הצהריים. עכשיו התזכורות יוצאות אוטומטית וחדר ההמתנה רץ בזמן.", name: "ד\"ר שי ת.", role: "רופא" },
      { quote: "המתאמנים נרשמים אונליין במקום להתקשר בעשר בלילה. כניסות, תשלומים וחידושים — הכל פשוט קורה. החזרתי לעצמי את הערבים.", name: "דולב ה.", role: "בעלים, חדר כושר" },
      { quote: "תיאום תספורת היה שלוש הודעות וואטסאפ הלוך ושוב. עכשיו זה שתי לחיצות. המספרה רצה לבד.", name: "צחי י.", role: "בעלים, מספרה" },
      { quote: "פניות שירות חיו בסקרינשוטים ובשיחות שפספסנו. עכשיו לכל עבודה יש מספר, סטטוס ומעקב. שום דבר לא נופל.", name: "ניצן א.", role: "בעלים, חברת מצלמות אבטחה" },
      { quote: "הייתי מבזבז חצי שבוע על מיילים עם רנדרים ומעקב אישורים. עכשיו הלקוחות צופים, מעירים ומאשרים במקום אחד — הפרויקטים זזים הרבה יותר מהר.", name: "עומר ג.", role: "אדריכל ומעצב" },
    ],
  },

  roi: {
    eyebrow: "מחשבון ROI",
    title: "כמה אוטומציה תחסוך לכם?",
    lede: "אומדן חיסכון שנתי. רוב האוטומציות מחזירות את עצמן ב-2-3 חודשים.",
    fields: {
      hours: "שעות עבודה ידנית בשבוע",
      rate: "עלות שעת עבודה ממוצעת ($)",
      teamSize: "כמה אנשים בצוות?",
    },
    annualSavedLabel: "חיסכון שעות-עבודה שנתי",
    paybackLabel: "תקופת החזר",
    paybackUnits: "חודשים",
    cta: "הצעת מחיר על בסיס זה",
    note: "אומדן בלבד. המספר האמיתי תלוי בהיקף.",
  },

  pricing: {
    eyebrow: "מחירים",
    title: "בחרו נקודת התחלה.",
    lede: "מחירים שקופים. את ההיקף הסופי בונים יחד בשיחת ההיכרות.",
    note: "ההיקף הסופי מוצע אחרי שיחת היכרות חינם של 20 דק'.",
    cta: "בוא נתחיל",
    currencyToggle: { usd: "USD ($)", ils: "ILS (₪)" },
    plans: [
      { key: "launch", name: "Launch", priceFromUSD: 625, priceLabelUSD: "החל מ-$625", priceLabelILS: "החל מ-₪2,250", tagline: "דפי נחיתה ואתרים שיווקיים", features: ["דף נחיתה שבנוי להמרה", "נראה מושלם בכל פלאפון", "נטען בפחות מ-2 שניות", "מוכן לחיפוש בגוגל", "עד 2 סבבי תיקונים", "מסירה תוך 3–7 ימים"], ctaLabel: "להתחיל דף נחיתה" },
      { key: "automate", name: "Automate", priceFromUSD: 1300, priceLabelUSD: "החל מ-$1,300", priceLabelILS: "החל מ-₪4,700", tagline: "בוטים ואוטומציות", features: ["בוט לטלגרם או וואטסאפ", "זרימת עבודה שמתאימה לעסק", "מתחבר לכלים שאתם כבר משתמשים בהם", "דשבורד ניהול פשוט", "אנחנו מאחסנים ומנטרים", "מסירה תוך 1–2 שבועות"], ctaLabel: "לאוטומציה שלי" },
      { key: "build", name: "Build", priceFromUSD: 3125, priceLabelUSD: "החל מ-$3,125", priceLabelILS: "החל מ-₪11,250", tagline: "מערכות מותאמות ופלטפורמות", features: ["מערכת מלאה, מקצה לקצה", "התחברות, תשלומים, דשבורדים", "תמיד אונליין ותמיד מעודכן", "מותאם לזרימה האמיתית שלכם", "30 ימי תמיכה אחרי השקה", "מסירה תוך 2–4 שבועות"], ctaLabel: "לבנות את המערכת שלי" },
    ],
  },

  guarantee: {
    eyebrow: "איך אנחנו עובדים",
    title: "היקף ברור. לוז כן. בלי הפתעות.",
    lede: "מסכמים מחיר, היקף ואבני דרך לפני שכותבים שורת קוד — כדי שתמיד תדעו מה אתם מקבלים ומתי.",
    items: [
      { icon: "shield", title: "מחיר קבוע מראש", desc: "מחיר ותנאים סגורים לפני שמתחילים. בלי הפתעות בחשבונית." },
      { icon: "lock", title: "אבני דרך שבועיות", desc: "רואים התקדמות אמיתית כל שבוע ומאשרים תוך כדי." },
      { icon: "code", title: "הכל שלכם", desc: "אחרי תשלום, הקוד יושב ב-GitHub שלכם, בדומיין ובענן שלכם." },
      { icon: "support", title: "30 ימי תמיכה", desc: "באגים והתאמות קטנות כלולים אחרי ההשקה." },
    ],
  },

  process: {
    eyebrow: "איך עובדים",
    title: "מרעיון לאוויר בשבועות, לא חודשים.",
    lede: "ארבעה שלבים, הכל פתוח. בלי הפתעות בחשבונית, בלי שאלות פתוחות.",
    steps: [
      { n: "01", title: "אפיון", desc: "פגישת היכרות קצרה. לומדים מה אתם רוצים, את מי משרתים ומה האילוצים." },
      { n: "02", title: "עיצוב", desc: "וויירפריימים ועיצוב במותג שלכם — רואים את המוצר לפני שכותבים שורת קוד." },
      { n: "03", title: "פיתוח", desc: "כותבים, מטסטים ומדפלוים. עדכונים יומיים בוואטסאפ, בלי לחכות לסיום." },
      { n: "04", title: "השקה", desc: "מעלים לאוויר, מנטרים, משפרים. כולל 30 ימי תמיכה אחרי ההשקה." },
    ],
  },

  about: {
    eyebrow: "מי מאחורי NKR",
    title: "היי, אני נווה.",
    lede: "אני בונה אתרים, מערכות זימון ואוטומציות לעסקים קטנים — מרפאות, חדרי כושר, מספרות, סוכני נדל\"ן וחנויות אונליין. דברים שחוסכים שעות בשבוע בלי שמרגישים את זה.",
    points: [
      "אני עושה הכל בעצמי — עיצוב, פיתוח והשקה.",
      "כל מה שנבנה — שלכם. הקוד, הדומיין והחשבונות.",
      "עדכונים בוואטסאפ. תמיד יודעים איפה הדברים עומדים.",
    ],
    cta: "בואו נדבר",
    initials: "NKR",
  },

  stack: {
    eyebrow: "ערכת כלים",
    title: "הכלים שאנחנו אוהבים, וגדלים איתם.",
    lede: "כל פרויקט מקבל את הכלי הנכון לו. בלי הנדסת יתר, בלי טרנדים סתם.",
    skills: {
      Languages: ["Java", "JavaScript", "Python", "SQL"],
      Frameworks: ["Spring Boot", "Hibernate", "React", "Node.js"],
      Databases: ["MySQL", "MongoDB"],
      Architecture: ["REST APIs", "Microservices", "OOP", "Design Patterns"],
      Tools: ["Git", "Jenkins", "Jira", "VS Code", "IntelliJ"],
      Methodologies: ["Agile/Scrum", "CI/CD", "Unit Testing", "Clean Code"],
    },
  },

  faq: {
    eyebrow: "שאלות",
    title: "מה שואלים לפני שלוחצים 'שלח'.",
    lede: "תשובות קצרות. אם השאלה שלכם לא כאן — שלחו הודעה, אנחנו עונים מהר.",
    items: [
      { q: "כמה זמן לוקח פרויקט?", a: "דף נחיתה — 3-7 ימים. בוט או אוטומציה — בדרך כלל 1-2 שבועות. אפליקציית פול-סטאק — 2-4 שבועות. נותנים לוז ברור לפני שמתחייבים." },
      { q: "הקוד שלי?", a: "תמיד. הקוד יושב ב-GitHub שלכם, בדומיין שלכם, בענן שלכם. בלי lock-in, אף פעם." },
      { q: "מה קורה עם שינויים אחרי ההשקה?", a: "כל פרויקט כולל 30 ימי תמיכה אחרי ההשקה — תיקונים והתאמות. אחר כך אפשר להמשיך אותנו לפי שעות, ריטיינר, או לקחת את הקוד." },
      { q: "חותמים על NDA?", a: "בכיף. נחתום על ה-NDA שלכם או על אחד הדדי סטנדרטי לפני שמשתפים פרטים רגישים." },
      { q: "איך עובד התשלום?", a: "בדרך כלל 50% מקדמה ו-50% בהשקה. לפרויקטים ארוכים מפצלים לאבני דרך. העברה בנקאית או Stripe." },
      { q: "אפשר לעבוד עם הצוות / המעצב/ת שלי?", a: "ברור. אנחנו עובדים מצוין עם צוותי בית, מעצבים וסוכנויות אחרות — מה שיעזור לכם להגיע לאוויר מהר יותר." },
      { q: "אתם בונים עם AI?", a: "כן — OpenAI, Anthropic ומודלים מקומיים כשצריך. שמים AI איפה שזה באמת עוזר, לא בגלל שזה טרנדי." },
      { q: "מה הפרויקט הקטן ביותר שאתם לוקחים?", a: "דף נחיתה אחד זה לגמרי בסדר. אם זה אפילו קטן יותר — נסו אותנו, יכול להיות שאנחנו מכירים מישהו שיתאים." },
    ],
  },

  banner: {
    title: "עוד לא מוכנים לפרויקט מלא?",
    desc: "קבעו אודיט חינם של 20 דקות. נעבור על האתר/בוט/תהליך שלכם ונשלח 3 ניצחונות מהירים — בלי התחייבות.",
    cta: "לקביעת אודיט חינם",
  },

  contact: {
    eyebrow: "דברו איתנו",
    title: "ספרו על הפרויקט.",
    lede: "כמה פרטים, ונחזור אליכם תוך 24 שעות עם הצעת מחיר ולוז.",
    bookCta: "לקביעת שיחת היכרות (20 דק')",
    orDivider: "או שלחו פרטים",
    form: {
      name: "איך קוראים לכם?",
      email: "מייל לחזרה",
      projectType: "סוג הפרויקט",
      projectTypeOptions: [
        { value: "", label: "בחרו סוג פרויקט" },
        { value: "landing", label: "דף נחיתה" },
        { value: "fullstack", label: "אפליקציית פול-סטאק" },
        { value: "automation", label: "אוטומציה" },
        { value: "crm", label: "CRM ייעודי" },
        { value: "telegram", label: "בוט טלגרם" },
        { value: "whatsapp", label: "בוט וואטסאפ" },
        { value: "other", label: "משהו אחר" },
      ],
      budget: "טווח תקציב",
      budgetOptions: [
        { value: "", label: "בחרו תקציב" },
        { value: "under-2k", label: "פחות מ-$2,000" },
        { value: "2-5k", label: "$2,000 – $5,000" },
        { value: "5-15k", label: "$5,000 – $15,000" },
        { value: "15k+", label: "$15,000+" },
        { value: "not-sure", label: "עדיין לא בטוח/ה" },
      ],
      timeline: "לוז",
      timelineOptions: [
        { value: "", label: "בחרו לוז" },
        { value: "asap", label: "כמה שיותר מהר" },
        { value: "1m", label: "תוך חודש" },
        { value: "1-3m", label: "1-3 חודשים" },
        { value: "exploring", label: "רק בודקים" },
      ],
      stage: "שלב",
      stageOptions: [
        { value: "", label: "בחרו שלב" },
        { value: "pre-revenue", label: "טרום-הכנסה / רעיון" },
        { value: "early", label: "הכנסה ראשונית" },
        { value: "growing", label: "עסק שצומח" },
        { value: "established", label: "עסק מבוסס" },
      ],
      message: "משהו נוסף?",
      submit: "שלחו לנו",
      sending: "שולח…",
      success: "קיבלנו! נחזור אליכם תוך 24 שעות.",
      error: "משהו השתבש. נסו שוב או כתבו לנו למייל.",
      spamDetected: "המסר נראה לנו אוטומטי. אם זו פנייה אמיתית, שלחו לנו ישירות במייל.",
    },
  },

  exitIntent: {
    title: "רגע — קבלו אודיט חינם לפני שתלכו.",
    desc: "השאירו מייל ונשלח לכם 3 ניצחונות מהירים לאתר/בוט/תהליך שלכם תוך 24 שעות. בלי שיחות מכירה, בלי ספאם.",
    emailLabel: "המייל שלכם",
    submit: "לשלוח לי אודיט",
    sending: "שולח…",
    success: "תודה! בדקו את תיבת המייל ב-24 השעות הקרובות.",
    error: "משהו לא עבר. נסו שוב או כתבו לנו למייל.",
    close: "לא תודה",
    later: "אולי בפעם אחרת",
  },

  mobileSticky: {
    primary: "להתחיל פרויקט",
    secondary: "וואטסאפ",
  },

  footer: "תוכנה שעובדת.",
};
